import { PopoverProps } from "@mui/material";
import { useState } from "react";

export type UsePopover = {
  anchorEl: HTMLElement | SVGSVGElement | null;
  isOpen: boolean;
  onPopoverClose: () => void;
  onPopoverOpen: (event: HTMLElement | SVGSVGElement) => void;
  popoverProps?: Partial<PopoverProps>;
};

export function usePopover(popoverProps?: Partial<PopoverProps>): UsePopover {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | SVGSVGElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const onPopoverOpen = (target: HTMLElement | SVGSVGElement) => {
    setAnchorEl(target);
  };

  const onPopoverClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    onPopoverClose,
    onPopoverOpen,
    isOpen,
    popoverProps,
  };
}
